// extracted by mini-css-extract-plugin
export default {"header":"Header_header__nJL39","lang":"Header_lang__w3W8b","burger":"Header_burger__wF7dd","logo":"Header_logo__PIYVx","logoSection":"Header_logoSection__UFcuw"};